import { memoize, merge } from 'lodash';

import { get } from '../../01-helpers/services/ajax';

const defaultParams = {};

let getHandicapHandout;

export default getHandicapHandout = memoize(data => {
	return get(
		'/api/mygame/scoringrecordimage',
		{
			// add data to api call
			data: merge({}, defaultParams, data)
		}
	)
});